import type { GetProject } from '@/server/api/rest/project';
import type { GetTranslationResponse } from '@/server/api/rest/translation';

type UseTranslatedProjectProps = {
  project: GetProject;
  translation?: GetTranslationResponse;
};

export const useTranslateProject = ({
  project,
  translation,
}: UseTranslatedProjectProps) => {
  const translatedProject =
    project || translation
      ? {
          ...project,
          title: translation?.title ?? project.title,
          subtitle: translation?.subtitle ?? project.subtitle,
          challenge: translation?.challenge ?? project.challenge,
          solution: translation?.solution ?? project.solution,
          result: translation?.result ?? project.result,
        }
      : undefined;

  return {
    project: translatedProject,
  };
};
